import { useState } from "react";
import { createSchoolFromServer } from "./createSchoolService";
import { useNavigate } from "react-router-dom";

const CreateSchool = () => {
    const navigate = useNavigate();
    
    const [formData, setFormData] = useState({
        name: "",
        family: "",
        phoneNumber: "",
        password: "",
        schoolName: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({ ...prev, [name]: value, }));
    };

    const submitHandler = async (e) => {
        e.preventDefault();

        try {
            await createSchoolFromServer(formData);

            navigate("/");
        } catch (e) {
            alert(e.response?.data?.message || "خطایی رخ داد");
        }
    };

    return (
        <div
            className="row m-0 min-vh-100 align-items-center justify-content-center"
            dir="rtl"
        >
            <div className="col-12 col-sm-10 col-md-7 col-lg-5">
                <div className="card border-0 shadow-sm rounded-4 p-4 p-md-5">
                    <div className="text-center mb-4">
                        <h2 className="fw-bold mb-2">ساخت مدرسه</h2>
                        <p className="text-muted mb-0">
                            اطلاعات مدیر و مدرسه را وارد کنید
                        </p>
                    </div>

                    <form onSubmit={submitHandler}>
                        <div className="row g-3">
                            <div className="col-md-6">
                                <label className="form-label fw-semibold">
                                    نام
                                </label>
                                <input
                                    type="text"
                                    name="name"
                                    className="form-control form-control-lg rounded-3"
                                    placeholder="نام"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="col-md-6">
                                <label className="form-label fw-semibold">
                                    نام خانوادگی
                                </label>
                                <input
                                    type="text"
                                    name="family"
                                    className="form-control form-control-lg rounded-3"
                                    placeholder="نام خانوادگی"
                                    value={formData.family}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="col-12">
                                <label className="form-label fw-semibold">
                                    شماره موبایل
                                </label>
                                <input
                                    type="tel"
                                    name="phoneNumber"
                                    className="form-control form-control-lg rounded-3"
                                    placeholder="09"
                                    value={formData.phoneNumber}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="col-12">
                                <label className="form-label fw-semibold">
                                    رمز عبور
                                </label>
                                <input
                                    type="password"
                                    name="password"
                                    className="form-control form-control-lg rounded-3"
                                    placeholder="رمز عبور"
                                    value={formData.password}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="col-12">
                                <label className="form-label fw-semibold">
                                    نام مدرسه
                                </label>
                                <input
                                    type="text"
                                    name="schoolName"
                                    className="form-control form-control-lg rounded-3"
                                    placeholder="نام مدرسه"
                                    value={formData.schoolName}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="col-12 mt-4">
                                <button type="submit" className="btn btn-primary btn-lg w-100 rounded-3" > ساخت مدرسه </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CreateSchool;